import React, { Component, useEffect, useState } from "react";
import {
  userAppPermissions,
  savePermissions,
  updateUserPermissions,
} from "apis";
import { withRedux, displayError, isLoading } from "helpers";
import Container from "@material-ui/core/Container";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import { AlertModal, HasPermission } from "components";
import Select from "react-select";
import { H1, H2, P, FormContainer, Form } from "appStyles";
import { permissionOptions } from "constants";
import AddCircleIcon from "@material-ui/icons/AddCircle";

function Permissions({
  activeApp: { id },
  platformInfo: {
    status: { user },
  },
  actions: { setDisplay, updateUserApplicationsPermissions },
}) {
  const loggedInUserId = String(user.id);
  const [users, setUsers] = useState({});
  const [success, toggleSuccess] = useState(false);
  const { [loggedInUserId]: currentUser, ...otherUsers } = users;

  useEffect(() => {
    fetchUserAppPermissions(id);
  }, []);

  const fetchUserAppPermissions = async (id) => {
    isLoading(true);
    const users = await userAppPermissions(id);
    setUsers(users);
    isLoading(false);
  };

  const uninviteUserAndRefetch = async (userId) => {
    await updateUserPermissions(userId, id);
    await fetchUserAppPermissions(id);
  };

  const handleSubmit = async (user) => {
    const { userId, appId, permissionIds } = user;
    const deletePermissions = [];
    permissionOptions.forEach(
      ({ value }) =>
        !permissionIds.includes(value) && deletePermissions.push(value)
    );
    const result = await savePermissions(userId, appId, permissionIds);
    if (deletePermissions.length !== 0) {
      await updateUserPermissions(userId, appId, deletePermissions);
    }
    if (currentUser.userId === userId)
      updateUserApplicationsPermissions(appId, permissionIds);
    result ? toggleSuccess(result) : displayError("Update permission failed");
  };

  const userPermissionsOnchange = (userId) => (permissions) => {
    const currentUser = users[userId];
    const permissionArray = permissions.map((p) => p.value);
    currentUser.permissionIds = permissionArray;
    setUsers({
      ...users,
      [userId]: currentUser,
    });
  };

  const renderPermissionOptions = (userId, permissionIds, disable) => {
    const value = permissionOptions.filter((option) =>
      permissionIds.includes(option.value)
    );
    return (
      <div
        style={{
          margin: "1em 0 1em 0",
          width: "100%",
        }}
      >
        <Select
          isMulti
          isDisabled={disable}
          name="permissions"
          value={value}
          // value={{
          //   value: 0,
          //   label: 'ADMIN'
          // }}
          options={permissionOptions}
          onChange={userPermissionsOnchange(userId)}
        />
      </div>
    );
  };

  const renderUserPermissions = () => {
    if (Object.keys(otherUsers).length === 0)
      return (
        <React.Fragment>
          <div
            style={{
              borderBottom: "1px solid #e8e8e8",
              padding: "1em 0em",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p
              style={{
                fontSize: "1.5em",
              }}
            >
              Admins
            </p>{" "}
          </div>

          <P margin="1em 0 1em 0">
            You can invite admins as co-editors to help create your app. Click
            the button below to invite!
          </P>
          <Button
            variant="contained"
            color="primary"
            style={{
              display: "inline-flex",
              alignItems: "center",
              margin: "0px",
              textAlign: "center",
              boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
            }}
            onClick={() =>
              setDisplay({
                view: "InviteUser",
                templateId: null,
              })
            }
          >
            Invite admins
          </Button>
        </React.Fragment>
      );

    return (
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          padding: 0,
        }}
      >
        <div
          style={{
            borderBottom: "1px solid #e8e8e8",
            padding: "1em 0em",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
            }}
          >
            Admins
          </p>
          <Button
            variant="contained"
            color="primary"
            style={{
              display: "inline-flex",
              alignItems: "center",
              margin: "0px",
              textAlign: "center",
              boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
            }}
            onClick={() =>
              setDisplay({
                view: "InviteUser",
                templateId: null,
              })
            }
          >
            Invite Admin
          </Button>
        </div>
        <p style={{ margin: "1.5em 0em" }}>
          You have {Object.keys(otherUsers).length} total admins.{" "}
        </p>
        {otherUsers &&
          Object.keys(otherUsers).map((userId) => {
            if (userId == loggedInUserId) return null;
            const user = users[userId];
            const { firstName, lastName, permissionIds, email } = user;

            return (
              <FormControl
                key={userId}
                style={{
                  margin: "1em 0 0 0",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    border: "1px solid rgb(173,173,166)",
                    padding: "10px",
                    borderRadius: "5px",
                  }}
                >
                  <p>
                    Name: {firstName} {lastName}
                    <br /> Email: {email}
                  </p>

                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => uninviteUserAndRefetch(userId)}
                    style={{
                      height: "3em",
                      marginLeft: "15px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "11px",
                      }}
                    >
                      Remove Admin
                    </p>
                  </Button>
                </div>

                <div
                  style={{
                    display: "flex",
                  }}
                >
                  {/* {permissionIds &&
                    renderPermissionOptions(userId, permissionIds)} */}
                  <div
                    style={{
                      width: "450px",
                      margin: "1em 0px 0px 1em",
                      display: "flex",
                    }}
                  >
                    {/* <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleSubmit(user)}
                      style={{
                        height: "3em",
                        marginBottom: "5px",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "11px",
                        }}
                      >
                        Update Permissions
                      </p>
                    </Button> */}
                  </div>
                </div>
              </FormControl>
            );
          })}
      </Container>
    );
  };

  const renderLoggedInUserPermissions = () => {
    if (!currentUser) return null;
    const { firstName, lastName, permissionIds, email, userId } = currentUser;

    return (
      <Container
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          padding: 0,
        }}
      >
        <div style={{ borderBottom: "1px solid #e8e8e8", padding: "1em 0em" }}>
          <H2
            style={{
              fontSize: "1.5em",
            }}
          >
            Admin Profile
          </H2>
        </div>
        <FormControl
          key={userId}
          style={{
            margin: "1em 0 1em 0",
          }}
        >
          <h3>
            Name: {firstName} {lastName}
          </h3>
          <h3>Email: {email}</h3>
          {/* {permissionIds && renderPermissionOptions(userId, permissionIds, true)} */}
          {/* <Button 
            variant="contained" 
            color="primary" 
            onClick={() => handleSubmit(currentUser)}
            style={{
              height: '3em'
            }}>
            Update Permissions
          </Button> */}
        </FormControl>
      </Container>
    );
  };

  const renderSuccessModal = () => {
    if (!success) return null;
    return (
      <AlertModal
        title="Permission Request"
        buttonText="Ok"
        render={success}
        hideModal={() => toggleSuccess(false)}
      >
        <p>Successfully updated permissions!</p>
      </AlertModal>
    );
  };

  return (
    <FormContainer width="735px" left="90px" top="20px">
      <H1>Manage App Permissions</H1>
      {renderSuccessModal()}
      {renderLoggedInUserPermissions()}
      <HasPermission permission={0}>{renderUserPermissions()}</HasPermission>
    </FormContainer>
  );
}

export default withRedux(Permissions);
